"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EvenOddValidatorKeys = void 0;
var EvenOddValidatorKeys;
(function (EvenOddValidatorKeys) {
    EvenOddValidatorKeys["DISALLOWED_EVEN_NUMBER"] = "DISALLOWED_EVEN_NUMBER";
    EvenOddValidatorKeys["DISALLOWED_ODD_NUMBER"] = "DISALLOWED_ODD_NUMBER";
})(EvenOddValidatorKeys = exports.EvenOddValidatorKeys || (exports.EvenOddValidatorKeys = {}));
//# sourceMappingURL=EvenOddValidatorKeys.js.map